import moment from 'moment';

export const HISTOGRAM_POINTS_LIMIT = 1500;

export const rangeMethods = {
  ['Today'](timeZoneId) {
    return [
      moment()
        .tz(timeZoneId)
        .startOf('day')
      ,
      moment()
        .tz(timeZoneId)
        .endOf('day')
    ];
  },
  ['Yesterday'](timeZoneId) {
    return [
      moment()
        .tz(timeZoneId)
        .subtract(1, 'days')
        .startOf('day'),
      moment()
        .tz(timeZoneId)
        .subtract(1, 'days')
        .endOf('day')
    ];
  },
  ['Last 2 days'](timeZoneId) {
    return [
      moment()
        .tz(timeZoneId)
        .startOf('day')
        .subtract(1, 'days'),
      moment()
        .tz(timeZoneId)
        .endOf('day')
    ];
  },
  ['Last 7 days'](timeZoneId) {
    return [
      moment()
        .tz(timeZoneId)
        .startOf('day')
        .subtract(6, 'days'),
      moment()
        .tz(timeZoneId)
        .endOf('day')
    ];
  },
  ['This week'](timeZoneId) {
    return [
      moment()
        .tz(timeZoneId)
        .startOf('isoWeek'),
      moment()
        .tz(timeZoneId)
        .endOf('isoWeek')
    ];
  },
  ['Last week'](timeZoneId) {
    return [
      moment()
        .tz(timeZoneId)
        .startOf('day')
        .day(-6),
      moment()
        .tz(timeZoneId)
        .endOf('day')
        .day(0)
    ];
  },
  ['Last Week'](timeZoneId) {
    return [
      moment()
        .tz(timeZoneId)
        .startOf('day')
        .day(-6),
      moment()
        .tz(timeZoneId)
        .endOf('day')
        .day(0)
    ];
  },
  ['Last 30 days'](timeZoneId) {
    return [
      moment()
        .tz(timeZoneId)
        .startOf('day')
        .subtract(29, 'days'),
      moment()
        .tz(timeZoneId)
        .endOf('day')
    ];
  },
  ['This month'](timeZoneId) {
    return [
      moment()
        .tz(timeZoneId)
        .startOf('month'),
      moment()
        .tz(timeZoneId)
        .endOf('month')
    ];
  },
  ['Last month'](timeZoneId) {
    return [
      moment()
        .tz(timeZoneId)
        .subtract(1, 'month')
        .startOf('month'),
      moment()
        .tz(timeZoneId)
        .subtract(1, 'month')
        .endOf('month')
    ];
  },
  ['Last 6 months'](timeZoneId) {
    return [
      moment()
        .tz(timeZoneId)
        .subtract(6, 'month')
        .startOf('day'),
      moment()
        .tz(timeZoneId)
        .endOf('day')
    ];
  },
  ['This year'](timeZoneId) {
    return [
      moment()
        .tz(timeZoneId)
        .startOf('year'),
      moment()
        .tz(timeZoneId)
        .endOf('year')
    ];
  }
};

export default function getRanges(timeZoneId) {
  return {
    'Today': rangeMethods['Today'](timeZoneId),
    'Yesterday': rangeMethods['Yesterday'](timeZoneId),
    'Last 2 days': rangeMethods['Last 2 days'](timeZoneId),
    'Last 7 days': rangeMethods['Last 7 days'](timeZoneId),
    'This week': rangeMethods['This week'](timeZoneId),
    'Last week': rangeMethods['Last week'](timeZoneId),
    'Last 30 days': rangeMethods['Last 30 days'](timeZoneId),
    'This month': rangeMethods['This month'](timeZoneId),
    'Last month': rangeMethods['Last month'](timeZoneId),
    'Last 6 months': rangeMethods['Last 6 months'](timeZoneId),
    'This year': rangeMethods['This year'](timeZoneId),
  };
}


export const timeIntervalToValueMapping = {
  'year': {
    code: 'datesByYear',
    format: 'YYYY',
    drilldown: true
  },
  'month': {
    code: 'datesByYearMonth',
    format: 'MMM, YYYY',
    drilldown: true
  },
  'week': {
    code: 'datesByYearMonthWeek',
    format: 'D MMM, YYYY',
    drilldown: true
  },
  'day': {
    code: 'datesByYearMonthDay',
    format: 'D MMM, YYYY',
    drilldown: true
  },
  'hour': {
    code: 'datesByYearMonthDayHour',
    format: 'D MMM, h:00 A',
    drilldown: true
  },
  'minute': {
    code: 'datesByYearMonthDayHourMinute',
    format: 'D MMM, h:mm A',
    drilldown: false
  },
};

export function findTimeInterval(timeInterval) {
  return Object.keys(timeIntervalToValueMapping).filter((key) => {
    return timeIntervalToValueMapping[key].code === timeInterval;
  })[0];
}

export const timeGroupDropdownOptions = [
  {
    label: 'Auto',
    code: 'auto'
  },
  {
    label: 'By year',
    code: timeIntervalToValueMapping['year'].code
  },
  {
    label: 'By month',
    code: timeIntervalToValueMapping['month'].code
  },
  {
    label: 'By week',
    code: timeIntervalToValueMapping['week'].code
  },
  {
    label: 'By day',
    code: timeIntervalToValueMapping['day'].code
  },
  {
    label: 'By hour',
    code: timeIntervalToValueMapping['hour'].code
  },
  {
    label: 'By minute',
    code: timeIntervalToValueMapping['minute'].code
  }
];

export function formatTimeInTimeZone(time, timeZoneId, format) {
  return moment.tz(time.format('YYYY-MM-DD HH:mm:ss'), timeZoneId).format(format);
}